import tw from "twin.macro";
import { TkaH3Span, TkaP2Span } from "@themes/font-tags";

export const SpacedContentsDiv = tw.div`flex gap-24 items-center`;
export const AnswerLetter = tw(TkaH3Span)``;
export const AnswerText = tw(TkaP2Span)`flex-grow`;
